import { Button } from '@/components/ui/button'

interface FamilyEditorSidebarFooterProps {
  mode: 'create' | 'update'
  isSubmitting: boolean
  submitDisabled: boolean
  onClose: () => void
  onSubmit: () => void
}

export function FamilyEditorSidebarFooter({
  mode,
  isSubmitting,
  submitDisabled,
  onClose,
  onSubmit,
}: FamilyEditorSidebarFooterProps) {
  return (
    <div className="sticky bottom-0 z-10 bg-background border-t px-6 py-4">
      <div className="flex items-center justify-end gap-2">
        <Button data-testid="editor-close-btn" variant="outline" onClick={onClose}>
          Fermer
        </Button>
        <Button data-testid="editor-submit-btn" onClick={onSubmit} disabled={submitDisabled}>
          {isSubmitting
            ? mode === 'update'
              ? 'Enregistrement...'
              : 'Ajout...'
            : mode === 'update'
              ? 'Enregistrer'
              : 'Ajouter'}
        </Button>
      </div>
    </div>
  )
}
